import cx from "classnames";
import React from "react";

import { TableBlock } from "../../types";
import { TABLE_SELECT_CONFIRMATION } from "../InnodomContent/Table";

type Props = Readonly<{
  block: TableBlock;
  children: React.ReactNode;
  confirmTableSelection: boolean;
  gutter: number;
  onDisableTableSelectionConfirmation: () => void;
  onSelectBlock: (blockId: string, textContent: string, replace: boolean) => void;
  onShowReferences: (zoneId: string) => void;
  scale: number;
  selected: boolean;
}>;
const TableZoneComponent = ({
  block,
  children,
  confirmTableSelection,
  gutter,
  onDisableTableSelectionConfirmation,
  onSelectBlock,
  onShowReferences,
  scale,
  selected,
}: Props) => {
  const style = {
    height: block.height * scale,
    left: block.x * scale + gutter,
    top: block.y * scale,
    width: block.width * scale,
  };
  return (
    <>
      <div
        className={cx("zone", block.confidenceClass, { selected })}
        id={block.id}
        onClick={e => {
          e.preventDefault();
          if (e.shiftKey && block.references.length > 0) {
            onShowReferences(block.id);
            return;
          }
          if (confirmTableSelection && !window.confirm(TABLE_SELECT_CONFIRMATION)) {
            return;
          }
          onDisableTableSelectionConfirmation();
          onSelectBlock(block.id, block.text, e.ctrlKey);
        }}
        style={style}
      />
      {children}
    </>
  );
};
TableZoneComponent.displayName = "TableZone";
export const TableZone = React.memo(TableZoneComponent);
